export function routes($stateProvider) {
    $stateProvider
        .state('app.gas', {
        url: '/gas',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.gas.calendario', {
        url: '/calendario?{funcionario:int}&{completed:int}&{open:int}',
        title: 'Calendarização',
        role: ['gasListarAgendamento'],
        template: require('./calendarizacao/view.html'),
        controller: 'GasCalendarizacaoController',
        controllerAs: 'vm',
        params: {
            completed: {
                value: 1,
                dynamic: true,
            },
            open: {
                value: 1,
                dynamic: true,
            },
        }
    });
}
routes.$inject = ['$stateProvider'];
